import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logger from '../utils/logger';

const ProtectedRoute = ({ children }) => {
  const { currentUser, user, isTokenValid, refreshToken, loading } = useAuth();
  const [tokenValid, setTokenValid] = useState(false);
  const [validating, setValidating] = useState(true);
  const [refreshAttempts, setRefreshAttempts] = useState(0);

  useEffect(() => {
    const validateToken = async () => {
    
      if (!currentUser || !user) {
        setTokenValid(false);
        setValidating(false);
        return <Navigate to="/signin" replace />;
      }

      try {
        // Check if token is still valid (await the async function)
        const isValid = await isTokenValid();
       
        if (isValid) {
          setTokenValid(true);
        } else {
          await refreshToken();
          setTokenValid(true);
        }
        
        // Additional safeguard: Check if user actually has valid session after refresh
        const userInfo = localStorage.getItem('userInfo');
        if (!userInfo) {
          return <Navigate to="/signin" replace />;
        }
      } catch (error) {
         setTokenValid(false);
      } finally {
        setValidating(false);
      }
    };

    if (!loading) {
       
      validateToken();
    }
  }, [currentUser, user, isTokenValid, refreshToken, loading]);

  if (loading || validating) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Validating session...</p>
        </div>
      </div>
    );
  }

  if (!currentUser || !user || !tokenValid) {
   return <Navigate to="/signin" replace />;
  }

  return children;
};

export default ProtectedRoute;
